import { jsx as _jsx } from "react/jsx-runtime";
import * as React from 'react';
import { useMeasure } from 'react-use';
import { StateContainer } from './StateContainer';
import { Details as StyledDetails } from './styles';
export const Details = ({ children, className, renderWhenCollapsed = false }) => {
    const { animate, isExpanded, showChildren } = StateContainer.useContainer();
    const [ref, { height }] = useMeasure();
    const maxHeight = React.useMemo(() => {
        if (!isExpanded)
            return '0';
        return isFinite(height ?? Infinity) ? `${height}px` : '100vh';
    }, [height, isExpanded]);
    return (_jsx(StyledDetails, { className: className, animate: animate, style: { maxHeight }, children: _jsx("div", { ref, children: renderWhenCollapsed ? children : showChildren && children }) }));
};
//# sourceMappingURL=Details.js.map